import type {
  ChangePasswordInput,
  SettingsResponse,
  UpdateDisplayNameInput,
  UpdateTimeZoneInput,
} from "@learn-flow/contracts";

import { apiRequest } from "../../lib/api.js";

export const settingsQueryKey = ["settings"] as const;

export function loadSettings(): Promise<SettingsResponse> {
  return apiRequest("/api/v1/settings");
}

export function saveDisplayName(input: UpdateDisplayNameInput): Promise<SettingsResponse> {
  return apiRequest("/api/v1/settings/display-name", {
    method: "PUT",
    body: JSON.stringify(input),
  });
}

export function saveTimeZone(input: UpdateTimeZoneInput): Promise<SettingsResponse> {
  return apiRequest("/api/v1/settings/timezone", {
    method: "PUT",
    body: JSON.stringify(input),
  });
}

export function changePassword(input: ChangePasswordInput): Promise<void> {
  return apiRequest("/api/v1/auth/password", {
    method: "PUT",
    body: JSON.stringify(input),
  });
}

export function deleteAccount(): Promise<void> {
  return apiRequest("/api/v1/settings/account", { method: "DELETE" });
}
